import React, { useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

const DiscountItems = ({ discountItems, editable, removeDiscountItems, handleDiscountItemsChange }) => {

  const handleInputChange = (event, index, key) => {
    const value = event.target.value;
    const newDiscountItems = [...discountItems];
    newDiscountItems[index] = { ...newDiscountItems[index], [key]: value };
    handleDiscountItemsChange(index, newDiscountItems[index]);
  };

  const actionTemplate = (rowData, column) => {
    return <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => removeDiscountItems(column.rowIndex)} />;
  };


  return (
    <>
      
          <DataTable value={discountItems} size="small" editMode="cell">
            <Column field="description" header="Description" editor={editable ? (props) =>
              <InputText value={discountItems[props.rowIndex]?.description} onChange={(e) => handleInputChange(e, props.rowIndex, 'description')} />
              : null} />
            <Column field="price" header="Price" editor={editable ? (props) =>
              <InputText value={discountItems[props.rowIndex]?.price} onChange={(e) => handleInputChange(e, props.rowIndex, 'price')} />
              : null} />
            {editable && <Column body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} />}
          </DataTable>
        
    </>
  );
};

export default DiscountItems;
